import React from 'react';
import { Route } from 'react-router';

import BasicLayout from './layouts/BasicLayout';
import IgAuthLayout from './layouts/IgAuthLayout';
import AppointmentConfirmation from './customer/CustomerNewAppointment';
import CustomerReminder from './customer/CustomerReminder';
import Receipt from './customer/Receipt';
import CustomerRebook from './customer/CustomerRebook';
import BarberNewAppointment from './barber/BarberNewAppointment';
import ShopNewAppointment from './shop/ShopNewAppointment';
import ShopReminder from './shop/ShopReminder';
import BarberReminder from './barber/BarberReminder';
import BarberUpdatedAppointment from './barber/BarberUpdatedAppointment';
import BarberCanceledAppointment from './barber/BarberCanceledAppointment';
import ShopUpdatedAppointment from './shop/ShopUpdatedAppointment';
import ShopCanceledAppointment from './shop/ShopCanceledAppointment';
import CustomerCanceledAppointment from './customer/CustomerCanceledAppointment';
import CustomerUpdatedAppointment from './customer/CustomerUpdatedAppointment';
import CustomerLoyaltyInitiation from './customer/CustomerLoyaltyInitiation';
import CustomerLoyaltyUpdate from './customer/CustomerLoyaltyUpdate';
import CustomerLoyaltyGrant from './customer/CustomerLoyaltyGrant';
import CustomerAddedToWaitingList from './customer/CustomerAddedToWaitingList';
import CustomerWaitingListNewSlot from './customer/CustomerWaitingListNewSlot';
import CustomerWaitingListPurged from './customer/CustomerWaitingListPurged';
import CustomerWaitingListRemoved from './customer/CustomerWaitingListRemoved';
import CustomerUnpaidAppointment from './customer/CustomerUnpaidAppointment';
import BarberIgAuth from './barber/BarberIgAuth';
import BarberIgAuthInstructions from './barber/BarberIgAuthInstructions';

// flagship
import FlagshipAppointmentConfirmation from './customer/Flagship/CustomerNewAppointment';
import FlagshipAppointmentCancelled from './customer/Flagship/CustomerAppointmentCancelled';
import FlagshipAppointmentReminder from './customer/Flagship/CustomerAppointmentReminder';
import WidgetAnnouncement from './announcements/WidgetAnnouncement';

// membership
import MembershipLayout from './layouts/MembershipLayout';
import MembershipCardExpiry from './membership/MembershipCardExpiry';
import MembershipMigration from './membership/MembershipMigration';
import MembershipAgreement from './membership/MembershipAgreement';

const NotificationsRoutes = () => (
  <Route path="/">
    <Route path="brands/:brandRoute/notifications">
      <Route component={BasicLayout}>
        <Route path="appointment-confirmation/:confirmationCode" component={AppointmentConfirmation} />
        <Route path="reminder/:confirmationCode" component={CustomerReminder} />
        <Route path="rebook/:confirmationCode" component={CustomerRebook} />
        <Route path="appointment-canceled/:confirmationCode" component={CustomerCanceledAppointment} />
        <Route path="appointment-updated/:confirmationCode" component={CustomerUpdatedAppointment} />
        <Route path="unpaid-appointment/:confirmationCode" component={CustomerUnpaidAppointment} />
        <Route path="barber-appointment/:confirmationCode" component={BarberNewAppointment} />
        <Route path="barber-reminder/:confirmationCode" component={BarberReminder} />
        <Route path="barber-updated/:confirmationCode" component={BarberUpdatedAppointment} />
        <Route path="barber-canceled/:confirmationCode" component={BarberCanceledAppointment} />
        <Route path="shop-appointment/:confirmationCode" component={ShopNewAppointment} />
        <Route path="shop-reminder/:confirmationCode" component={ShopReminder} />
        <Route path="shop-updated/:confirmationCode" component={ShopUpdatedAppointment} />
        <Route path="shop-canceled/:confirmationCode" component={ShopCanceledAppointment} />
        <Route path="receipt/:id/:transactionId" component={Receipt} />
        <Route path="loyalty-initiation/:confirmationCode" component={CustomerLoyaltyInitiation} />
        <Route path="loyalty-update/:confirmationCode" component={CustomerLoyaltyUpdate} />
        <Route path="loyalty-grant/:confirmationCode/reward/:customerRewardId" component={CustomerLoyaltyGrant} />
        <Route path="waiting-list-confirmed/:customerWaitingListId" component={CustomerAddedToWaitingList} />
        <Route path="waiting-list-new-time-slot/:customerWaitingListId" component={CustomerWaitingListNewSlot} />
        <Route path="waiting-list-purged/:customerWaitingListId" component={CustomerWaitingListPurged} />
        <Route path="waiting-list-removed/:customerWaitingListId" component={CustomerWaitingListRemoved} />
      </Route>
    </Route>
    <Route path="notifications">
      <Route component={BasicLayout}>
        <Route path="appointment-confirmation/:confirmationCode" component={AppointmentConfirmation} />
        <Route path="reminder/:confirmationCode" component={CustomerReminder} />
        <Route path="rebook/:confirmationCode" component={CustomerRebook} />
        <Route path="appointment-canceled/:confirmationCode" component={CustomerCanceledAppointment} />
        <Route path="appointment-updated/:confirmationCode" component={CustomerUpdatedAppointment} />
        <Route path="unpaid-appointment/:confirmationCode" component={CustomerUnpaidAppointment} />
        <Route path="barber-appointment/:confirmationCode" component={BarberNewAppointment} />
        <Route path="barber-reminder/:confirmationCode" component={BarberReminder} />
        <Route path="barber-updated/:confirmationCode" component={BarberUpdatedAppointment} />
        <Route path="barber-canceled/:confirmationCode" component={BarberCanceledAppointment} />
        <Route path="shop-appointment/:confirmationCode" component={ShopNewAppointment} />
        <Route path="shop-reminder/:confirmationCode" component={ShopReminder} />
        <Route path="shop-updated/:confirmationCode" component={ShopUpdatedAppointment} />
        <Route path="shop-canceled/:confirmationCode" component={ShopCanceledAppointment} />
        <Route path="receipt/:id/:transactionId" component={Receipt} />
        <Route path="loyalty-initiation/:confirmationCode" component={CustomerLoyaltyInitiation} />
        <Route path="loyalty-update/:confirmationCode" component={CustomerLoyaltyUpdate} />
        <Route path="loyalty-grant/:confirmationCode/reward/:customerRewardId" component={CustomerLoyaltyGrant} />
        <Route path="waiting-list-confirmed/:customerWaitingListId" component={CustomerAddedToWaitingList} />
        <Route path="waiting-list-new-time-slot/:customerWaitingListId" component={CustomerWaitingListNewSlot} />
        <Route path="waiting-list-purged/:customerWaitingListId" component={CustomerWaitingListPurged} />
        <Route path="waiting-list-removed/:customerWaitingListId" component={CustomerWaitingListRemoved} />

        <Route path="flagship-appointment-confirmation/:confirmationCode" component={FlagshipAppointmentConfirmation} />
        <Route path="flagship-appointment-reminder/:confirmationCode" component={FlagshipAppointmentReminder} />
        <Route path="flagship-appointment-cancellation/:confirmationCode" component={FlagshipAppointmentCancelled} />
      </Route>
      <Route component={IgAuthLayout}>
        <Route path="barber-ig-auth" component={BarberIgAuth} />
        <Route path="barber-ig-auth-instructions" component={BarberIgAuthInstructions} />
      </Route>
      <Route path="widget-announcement/:brandId" component={WidgetAnnouncement} />
      <Route component={MembershipLayout}>
        <Route path="card-expiry" component={MembershipCardExpiry} />
        <Route path="membership-migration" component={MembershipMigration} />
        <Route path="membership-agreement" component={MembershipAgreement} />
      </Route>
    </Route>
  </Route>
);

export default NotificationsRoutes;



// WEBPACK FOOTER //
// ./src/app/notifications/routes.jsx